import { Button } from 'antd';
import styled from 'styled-components';

export const NewDocumentButton = styled(Button)`
  margin-top: 20px;
`;

export const NoDocumentToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
  padding: 12px 16px;
  border: 1px solid ${props => (props.active ? '#91d5ff' : '#e8e8e8')};
  border-radius: 8px;
  background: ${props => (props.active ? '#e6f7ff' : '#fafafa')};
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
  user-select: none;

  &:hover {
    border-color: #40a9ff;
  }
`;

export const NoDocumentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const NoDocumentTexts = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.3;
`;

export const NoDocumentTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #262626;
`;

export const NoDocumentSubtitle = styled.span`
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 2px;
`;

export const Footer = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background-color: #fff;
  text-align: right;
`;

export const BackButton = styled(Button)`
  margin-right: 8px;
`;

export const BottonsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
`;